import { render, staticRenderFns } from "./setRemind.vue?vue&type=template&id=b95c4982&scoped=true&"
import script from "./setRemind.vue?vue&type=script&lang=js&"
export * from "./setRemind.vue?vue&type=script&lang=js&"
import style0 from "./setRemind.vue?vue&type=style&index=0&id=b95c4982&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95c4982",
  null
  
)

export default component.exports